module.exports = __webpack_public_path__ + "static/media/subscribe-top-arc.8cd945e8.svg";